module.exports = __webpack_public_path__ + "static/media/daily-double.23840f5e.jpeg";